import React from "react";
import {
  VACANCY_CANDIDATE_VISIBILITY,
  VACANCY_SELECTION_METHOD,
} from "../../models/vacancy";
import { TVacancy, TVacancyDetail } from "../../store/vacancy/types";
import { capitalizeName } from "../../utils/stringUtils";

interface VacancySettingsProps {
  vacancy: TVacancy | TVacancyDetail;
}

const VacancySettings: React.FC<VacancySettingsProps> = ({ vacancy }) => {
  const {
    visibility_type,
    selected_candidate,
    selected_candidate_id,
    selection_method,
    applications_count,
  } = vacancy;

  const isSelectedCandidate =
    visibility_type === VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE;

  const visibilityLabel =
    visibility_type === VACANCY_CANDIDATE_VISIBILITY.PREFERRED_CANDIDATES
      ? "Preferred"
      : isSelectedCandidate
      ? "Shared with"
      : "Public";

  const showSelectedCandidate =
    isSelectedCandidate && selected_candidate_id && selected_candidate;

  const handleSelectionMethod = () => {
    let lebel = "";
    if (selection_method === VACANCY_SELECTION_METHOD.FIRST_COME_FIRST_SERVED) {
      lebel += "First To Accept";
    }
    return lebel;
  };

  return (
    <>
      <div className="fs-13">{visibilityLabel}</div>
      {!isSelectedCandidate &&
        selection_method !==
          VACANCY_SELECTION_METHOD.FIRST_COME_FIRST_SERVED && (
          <div
            className={`fs-13 fw-700 ${
              applications_count < 1 ? "text-grey-light" : "text-teal-dark"
            }`}
          >
            {applications_count}{" "}
            {applications_count <= 1 ? "Application" : "Applications"}
          </div>
        )}

      {showSelectedCandidate && (
        <div className="fs-13 fw-700 text-black">
          {`${capitalizeName(selected_candidate.first_name ?? "")} ${capitalizeName(selected_candidate.last_name ?? "")}`}
        </div>
      )}
      {!isSelectedCandidate && (
        <div className="fw-700 text-grey-light">{handleSelectionMethod()}</div>
      )}
    </>
  );
};

export default VacancySettings;
